import { Injectable } from "@angular/core";
import { SelectOption } from "pax-ui/components";
import { concatMap, map, Observable } from "rxjs";
import {
  NationalityHttpService,
  NationalityResponseDto,
} from "../../backend/nationality/nationality-http.service";
import { HttpLifecycleService } from "../../backend/shared/http-lifecycle.service";
import { ExternalEndpoint } from "../../external-system-communication-state.service";

@Injectable({
  providedIn: "root",
})
export class NationalityDomainService {
  private readonly _shareReplayNationalityOptions$: Observable<NationalityResponseDto>;

  constructor(
    private readonly _nationalityHttpService: NationalityHttpService,
    private readonly _httpLifecycleService: HttpLifecycleService,
  ) {
    this._shareReplayNationalityOptions$ =
      this.initializeNationalitiesSharedObservable();
  }

  getNationalities() {
    return this._shareReplayNationalityOptions$.pipe(
      map((response) => {
        return response.nationalities.map((nationalityDto) => {
          const selectionOption: SelectOption = {
            label: nationalityDto.country,
            value: nationalityDto.code,
            disabled: false,
          };

          return selectionOption;
        });
      }),
    );
  }

  private initializeNationalitiesSharedObservable() {
    return this._httpLifecycleService
      .createDefaultHttpObservable(
        ExternalEndpoint.NATIONALITIES_GET_NATIONALITIES,
      )
      .pipe(
        concatMap(() => this._nationalityHttpService.getNationalities()),
        this._httpLifecycleService.createShareReplayObservable(
          ExternalEndpoint.NATIONALITIES_GET_NATIONALITIES,
        ),
      );
  }
}
